import * as React from "react";

import { BRAND } from "~/brand";
import { AnwbLogo } from "~/brand/AnwbLogo";
import { cn } from "~/lib/utils";

export default function Logo({ className, ...props }: React.ComponentProps<"svg">) {
  if (BRAND.id === "anwb") {
    // The ANWB logo is wide, so a square size-* slot only sets its height.
    const height = className?.replace(/\bsize-/g, "h-");
    return <AnwbLogo className={cn("h-10 w-auto", height)} />;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      className={cn(className)}
      {...props}
    >
      <path
        d="M22.836 14.3152H17.6965L21.0993 6H18.3295L10 20.083H20.0252L22.836 14.3152Z"
        fill="#292B34"
      />
      <path
        d="M17.1622 25.852H22.3017L18.8989 34.1672H21.6686L29.9981 20.0842L19.973 20.0842L17.1622 25.852Z"
        fill="#292B34"
      />
    </svg>
  );
}
